import { registerModalA11yClose, registerModalA11yOpen } from "./a11y";

export function openModal(overlay: HTMLElement): void {
  if (overlay.classList.contains("is-open")) {
    return;
  }
  overlay.classList.add("is-open");
  overlay.setAttribute("aria-hidden", "false");
  registerModalA11yOpen(overlay);
}

export function closeModal(overlay: HTMLElement): void {
  if (!overlay.classList.contains("is-open")) {
    return;
  }
  overlay.classList.remove("is-open");
  overlay.setAttribute("aria-hidden", "true");
  registerModalA11yClose(overlay);
}
